import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { ToastController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import moment from 'moment';
import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import { ConfigService } from 'src/app/provider/config.service';
import { AuthService } from 'src/app/services/auth.service';
import { Subscription } from 'rxjs';
import { AreaListsPage } from 'src/app/pages/area-lists/area-lists.page';

@Component({
  selector: 'app-edit-address',
  templateUrl: './edit-address.page.html',
  styleUrls: ['./edit-address.page.scss'],
  host: {
    // 2. Define the 'id' attribute and its static value
    'id': 'hostElem' 
  },
  standalone: false,
})
export class EditAddressPage implements OnInit, OnDestroy {
  public settings?: any;
  private appSettingsSubscription?: Subscription;
  customer?: any;
  storeData: any = {};
  address_fields: any[] = [];
  areaSlots: any = [];
  areasOrRegion: any = [];
  areasOrRegionId: any = null;
  areasOrRegionName?: string;
  areaSlotId: any = null;
  governorateId: any = null;
  @Input() addid: string = 'newAddress';
  @Output() addressSubmitted = new EventEmitter<boolean>();
  address?: any;
  historyRoute = 'address-lists';
  address_name: string = '';
  phone?: number;
  block: any = '';
  street: any = '';
  house_name: any = '';
  avenue: any = '';
  floor: any = '';
  flat: any = '';
  landmark: any = '';
  latitude: any = 0;
  longitude: any = 0;
  compound_code: any = '';
  global_code: any = '';
  PACI_number: any = '';
  location: any = '';
  driver_note: any = '';
  zip_code: any = '';
  notes: any = '';
  addressForm: any = {};
  is_default?: any;
  constructor(
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private configService: ConfigService,
    private apiService: ApiService,
    private authService: AuthService,
  ) {
    this.customer = this.authService.getAuthUser();
  }
  async ngOnInit() {
    this.appSettingsSubscription = this.configService.appSettings$.subscribe((currentSettings: any) => {
      this.settings = currentSettings;
    });
    
    this.apiService
      .get(endpoints.areas)
      .pipe(first())
      .subscribe((response: any) => {
        if (response.success) {
          this.areasOrRegion = response.data?.areas;
        }
      });
    
    const orgData = await this.configService.configurationsSync(); 
    this.storeData = orgData.organization;
    this.address_fields = this.storeData.address_fields;
    if (this.addid == 'newAddress') {
      this.addressForm = {}; // Initialize addressForm as an empty object first
      this.addressForm.name = "";
      this.address_fields?.forEach((field: any) => {
        this.addressForm[field] = ''; // Or null, or a default value
      });
      this.address = {}; // Initialize addressForm as an empty object first

      this.address_fields?.forEach((field: any) => {
        this.address[field] = ''; // Or null, or a default value
      });
    } else {
      this.apiService
        .get(endpoints.addresses + '/' + this.addid + '?customer_id=' + this.customer.id)
        .pipe(first())
        .subscribe((response: any) => {
          if (response.success) {
            this.addressForm = {};
            this.address = response.data?.address;

            this.addressForm.latitude = this.address.latitude ? this.address.latitude : this.latitude;
            this.addressForm.longitude = this.address.longitude ? this.address.longitude : this.longitude;
            this.addressForm.areaSlotId = this.address.slot_id;
            this.addressForm.areasOrRegionId = this.address.area_id;
            this.addressForm.area = this.address.area;

            this.onAreaChange(this.address.area_id);
            this.addressForm.name = this.address.name;
            this.addressForm.phone = this.address.phone;
            this.addressForm.house_name = this.address.house_name;
            this.addressForm.block = this.address.block;
            this.addressForm.street = this.address.street;
            this.addressForm.avenue = this.address.avenue;
            this.addressForm.floor = this.address.floor;
            this.addressForm.flat = this.address.flat;

            const myJsonObject = {
              name: 'John Doe',
              age: 30,
              isStudent: false,
              courses: ['Angular', 'Ionic'],
            };

            // Convert the JSON object to a string
            const myJsonString = JSON.stringify(myJsonObject);

            if (this.address.notes == 'hello') {
              this.addressForm.landmark = myJsonString;
            } else {
              this.addressForm.landmark = this.address.landmark;
            }

            this.addressForm.PACI_number = this.address.PACI_number;
            this.addressForm.zip_code = this.address.zip_code;
            this.addressForm.location = this.address.location ? this.address.location : 'no-location';
            this.addressForm.driver_note = this.address.driver_note;
            this.addressForm.notes = this.address.notes;
          }
        });
    }
  // Keyboard handling is now managed by KeyboardService
this.addressForm.customer_id = this.customer.id;
    this.addressForm.is_default = this.is_default ? this.is_default : false;
    this.onAreaChange(this.addressForm.areasOrRegionId);
    this.addressForm.slot_id = this.addressForm.areaSlotId;
  }
  ngOnDestroy() {
    if (this.appSettingsSubscription) {
      this.appSettingsSubscription?.unsubscribe();
    }
  }
  onSubmitAddress = () => {
    this.addressForm.customer_id = this.customer.id;
    this.addressForm.is_default = this.is_default ? this.is_default : false;

    this.addressForm.slot_id = this.addressForm.areaSlotId;

    if (this.addid == 'newAddress') {
      const newForm = this.addressForm;

      this.apiService
        .post(endpoints.addresses, newForm)
        .pipe(first())
        .subscribe(
          (response) => {
            if (response.success) {
              this.toastMessage(response.message);
              this.addressSubmitted.emit(true);
              this.modalCtrl?.dismiss(true, 'close');
            } else {
              this.toastMessage(response.message);
            }
          },
          (err) => {
            Object.keys(err.error).forEach((key: any) => {
              const errorArray = err.error[key];
              Object.keys(errorArray).forEach((index: any) => {
                this.toastMessage(errorArray[index]);
              });
            });
          },
        );
    } else {
      const addUpdateFormValue = this.addressForm;
      this.apiService
        .put(endpoints.addresses + '/' + this.addid, addUpdateFormValue)
        .pipe(first())
        .subscribe(
          (response) => {
            if (response.success) {
              this.toastMessage(response.message);
              this.addressSubmitted.emit(true);
              this.modalCtrl?.dismiss(true, 'close');
            } else {
              this.toastMessage(response.message);
            }
          },
          (err) => {
            Object.keys(err.error).forEach((key: any) => {
              const errorArray = err.error[key];
              Object.keys(errorArray).forEach((index: any) => {
                this.toastMessage(errorArray[index]);
              });
            });
          },
        );
    }
    
  };
  openAreaModal = async () => {
    const areaModal = await this.modalCtrl?.create({
      component: AreaListsPage,
      componentProps: {
        citylist: this.areasOrRegion,
        orginallist: this.areasOrRegion,
      },
    });
    areaModal.onDidDismiss().then((data: any) => {
      if (data.data) {
        this.addressForm.area_id = data.data.id;
        this.addressForm.area = this.settings?.appLanguage == 'ar' ? data.data.a_title : data.data.title;

        this.onAreaChange(data.data.id);
      }
    });
    return areaModal.present();
  };
  onAreaChange = (area_id: any) => {
    this.apiService
      .get(endpoints.slots + '?area_id=' + area_id)
      .pipe(first())
      .subscribe((response: any) => {
        if (response.success) {
          this.areaSlots = response.data?.slots;

          this.areaSlots?.forEach((data: any) => {
            data.delivery_start_time = moment(data.start_time, 'HH:mm:ss').format('hh:mm A');
            data.delivery_end_time = moment(data.end_time, 'HH:mm:ss').format('hh:mm A');
          });
        }
      });
    this.areasOrRegion?.map((area: any) => {
      if (area.id == area_id) {
        this.addressForm.governorate_id = area.governorate_id;
      }
    });
  };
  toastMessage = async (msg: any) => {
    await this.toastCtrl
      .create({
        message: this.translate?.instant(msg),
        duration: 4000,
        position: 'top',
        color: 'light',
      })
      .then((toastElem: any) => toastElem.present());
  };
  numberValidation = (event: any) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (event.target?.value.length > 7) {
      event.target.value = event.target.value.slice(0, 7);
    }
    return true;
  };
  closeModal = () => {
    this.modalCtrl?.dismiss(null, 'cancel');
  };
}
